<div class="container-fluid px-0 h-100">
  <div class="h-100  d-flex  justify-content-between">
    <!-- card 1 -->
    <div class="flex-grow-1 px-3 container_content">
      <div class="row justify-content-center">
        <div class="m-w-520 py-md-5 col-12">
          <!-- main page login starts  -->
          <div class="row py-md-5 py-4 flex-wrap" *ngIf="changePanel == 0">
            <div class="col-12 mt-3">
              <img src="assets/img/svg/logo_login.svg" alt="" srcset="">
            </div>
            <div class="col-12 mt-5">
              <h1 class="h1 f-w-800">
                Welcome <br /> to <span style="color:var(--d-blue)" class="notranslate ps-1">Denefits!</span>
              </h1>
            </div>
            <!-- <div class="col-12 mt-5">
              <p class="f-c-p-1">
                Sign In with social media
              </p>
            </div>
            <div class="col-md-4 col-12 my-2 my-md-0">
              <button social-login-button tappable>
                <img src="assets/img/svg/google.svg" alt="">
                <span>
                  Google
                </span>
              </button>
            </div>
            <div class="col-md-4 col-12 my-2 my-md-0">
              <button social-login-button tappable>
                <img src="assets/img/svg/facebook.svg" alt="">
                <span>
                  Facebook
                </span>
              </button>
            </div>
            <div class="col-md-4 col-12 my-2 my-md-0">
              <button social-login-button tappable>
                <img src="assets/img/svg/apple.svg" alt="">
                <span>
                  Apple ID
                </span>
              </button>
            </div> -->
            <!-- <div class="col-12 my-3">
              <span class="d-flex align-items-center">
                <hr class=" flex-grow-1" />
                <span class="h6 mb-0 px-2 f-c-p-2">
                  Or, enter your credentials to sign in
                </span>
                <hr class=" flex-grow-1" />
              </span>
            </div> -->

            <ng-container [formGroup]="user">

              <div class="col-12 form-group mt-4">
                <div
                  [ngClass]="[ (user.controls.email.touched && user.controls.email.invalid) || user.controls.email.errors?.emial_phone_null  ? 'custom-form  inputContainer' : 'custom-form']">
                  <input type="text" class="input_field pt-3 px-3" (keydown.enter)="enterPassword_form()" name="email"
                    required formControlName="email" autocomplete="off" id="enter_email" />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      Enter your Email or Phone
                    </span>
                  </label>
                </div>
                <p class="mat-error w-100 d-block"
                  *ngIf="(user.controls.email.errors && user.controls.email.errors.emial_phone_null )|| (user.controls.email.touched && user.controls.email.invalid)">
                  {{user.controls.email.errors && user.controls.email.errors.emial_phone_null ?
                  user.controls.email.errors.emial_phone_null : 'Please enter a valid Email/Phone'}} </p>
              </div>
              <div class="col-12 form-group d-flex flex-column flex-sm-row align-items-center mt-2">
                <button button-primary-auth (click)="user.markAsPristine();enterPassword_form()" type="submit"
                  class="me-sm-2 mb-2 mb-sm-0 col-12 col-sm-auto" id="password_button">Enter
                  Password</button>
                  <span class="pe-2">
                    OR
                  </span>
                <button button-primary-auth class="col-12 col-sm-auto" (click)="GenerateOtp()">Generate Verification Code</button>
              </div>

              <div class="w-100 h-6 fw-bold col-12 pointer mt-3 h6">
                <span class="f-c-p-1">
                  New to<span class="notranslate ps-1">Denefits</span>? 
                  <a (click)="register();" class="d-blue">Sign Up Now</a>
                </span>
              </div>
            </ng-container>
          </div>
          <!-- ends -->
          <!-- forgot password starts -->
          <div class="row py-5 flex-wrap" *ngIf="changePanel == 1">
            <div class="col-12 mb-md-4 ps-md-4">
              <div class="button_class" (click)="changePanel = 0">
                <div>
                  <img src="assets\img\svg\back_arrow.svg" class="me-2">
                </div>
                <div>
                  <span class="f-c-p-1 d-inline-block me-2">
                    Back
                  </span>
                </div>
              </div>
            </div>
            <form [formGroup]="user" (ngSubmit)="passwordSignin()" class="col-12">
              <div class="col-12 mt-5">
                <h1 class="fw-bolder">
                  Enter your account <br />
                  password to sign in
                </h1>
              </div>

              <div class="col-12 form-group pe-md-0 mt-5">
                <div
                  [ngClass]="[ (user.controls.password.touched && user.controls.password.invalid) || user.controls.password.errors?.password_null  ? 'custom-form  inputContainer' : 'custom-form']">
                  <input [type]="hidePwd ? 'password':'text'" class="input_field pt-3 px-3" name="password"
                    autocomplete="off" required formControlName="password" id="enter_password" />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      Enter your Password
                    </span>
                  </label>
                  <button style="position: absolute;top: 7\px;right: 10px;cursor: pointer;" type="button"
                    mat-icon-button class="d-inline me-2" matSuffix (click)="hidePwd = !hidePwd"
                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePwd">
                    <mat-icon>{{hidePwd ? 'visibility_off' : 'visibility'}}</mat-icon>
                  </button>
                </div>
                <p class="mat-error w-100 d-block"
                  *ngIf="(user.controls.password.invalid && user.controls.password.touched) ||  user.controls.password.errors?.password_null">
                  {{user.controls.password.errors && user.controls.password.errors.password_null ?
                  user.controls.password.errors.password_null || 'Please enter a
                  valid Password' : 'Please enter a
                  valid Password'}}</p>
                <a routerLink="/forgot-password" class="fw-bold mt-2 d-inline">Forgot Password</a>
              </div>

              <div class="col-12 mt-4">
                <button autofocus button-primary-auth type="submit" id="sign_in">Sign In</button>
              </div>
            </form>
          </div>


          <!-- ends -->
          <!-- Enter otp Page -->
          <form [formGroup]="user" (ngSubmit)="verifyOtp()" class="row py-5 flex-wrap" *ngIf="changePanel == 2;">
            <div class="col-12 mb-md-5">
              <button tabindex="-1" (click)="changePanel = 0;" class="d-flex align-item-center p-2 border border_50">
                <img src="assets\img\svg\back_arrow.svg" class="me-2" style="height: 24px;">
                <span class="f-c-p-1 d-inline-block me-2">
                  Back
                </span>
              </button>
            </div>

            <div class="col-12 mt-5">
              <h1 class="fw-bolder">
                Enter the 6-digit Verification Code
              </h1>
            </div>
            <div class="col-12 form-group pe-md-0 mt-5">
              <span class="d-inline-block w-100 h6  fw-bold"><span class="f-c-p-1 h6 fw-bold">Verification Code has
                  been sent to
                </span>{{email_otp}}</span>
              <div
                [ngClass]="[ (user.controls.otp.touched && user.controls.otp.invalid) || user.controls.otp.errors?.emial_otp_none  ? 'custom-form  inputContainer' : 'custom-form']">
                <input type="text" class="input_field pt-3 px-3" name="OTP" autocomplete="off" required
                  formControlName="otp" maxlength="6" autofocus appNumbersOnly />
                <label for="text" class="label-name">
                  <span class="content-name f-c-p-3">
                    Enter Verification Code
                  </span>
                </label>
              </div>
              <p class="mat-error w-100 d-block"
                *ngIf="(user.controls.otp.touched && user.controls.otp.invalid) ||  user.controls.otp.errors?.emial_otp_none">
                {{user.controls.otp.errors && user.controls.otp.errors.emial_otp_none ?
                user.controls.otp.errors.emial_otp_none : 'Please enter a
                valid Verification Code'}}</p>
              <!-- <a routerLink="/forgot-password" class="fw-bold mt-2 d-block">Forgot Password</a> -->
              <div class="d-flex justify-content-between py-2">
                <div class="h6"><span class="f-c-p-1">Request for new Verification Code after </span> 
                  <span class="notranslate">{{resendTime}}</span>
                </div>
                <div (click)="time==0 && GenerateOtp()" role="link"
                  [ngClass]="[time == null || time !== 0 ? 'f-c-p-3 fw-bold pointer' : 'd-blue  fw-bold pointer']">
                  Resend</div>
              </div>
            </div>
            <!-- ends -->
            <div class="col-12 mt-4">
              <button autofocus button-primary-auth type="submit">Sign In</button>
            </div>
          </form>
          <!-- ends -->

        </div>
      </div>
    </div>
    <!-- Card 2  -->
    <div class=" d-sm-none d-none d-sm-none d-md-block img_bg container_carousel flex-grow-1 m-w-40p">
      <app-carousel></app-carousel>
    </div>
  </div>
</div>